// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var loading;
export function loadBrowserTrustee() {
    var _this = this;
    if (!loading) {
        loading = (function () { return __awaiter(_this, void 0, void 0, function () {
            var base, module;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!window.crossOriginIsolated)
                            throw new Error("Browser trustees require HTTPS and cross-origin isolation (COOP/COEP).");
                        base = new URL("/wbraid-trustee/", window.location.origin);
                        return [4 /*yield*/, import(
                            /* webpackIgnore: true */ /* @vite-ignore */ new URL("index.js", base).href)];
                    case 1:
                        module = _a.sent();
                        return [4 /*yield*/, module.default({ module_or_path: new URL("index_bg.wasm", base).href })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, module.initThreadPool(Math.min(navigator.hardwareConcurrency || 2, 4))];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, module];
                }
            });
        }); })().catch(function (error) {
            loading = undefined;
            throw error;
        });
    }
    return loading;
}
function parseCustodyActions(value) {
    if (typeof value !== "object" || value === null)
        throw new Error("Invalid trustee event updates.");
    if (!("actions" in value))
        return [];
    if (!Array.isArray(value.actions))
        throw new Error("Invalid trustee actions.");
    var actions = [];
    var _loop_1 = function (action) {
        if (typeof action !== "object" || action === null || !("kind" in action))
            throw new Error("Invalid trustee action.");
        // Future action kinds must not stop this runner's protocol boards.
        if (action.kind !== "CREATE_CUSTODY_PROOF")
            return "continue";
        if (!("id" in action) || typeof action.id !== "string" || !("request" in action))
            throw new Error("Invalid custody action.");
        var request = action.request;
        if (typeof request !== "object" ||
            request === null ||
            ![
                "tenant_id",
                "election_event_id",
                "keys_ceremony_id",
                "trustee_name",
                "signing_public_key",
                "share_encryption_public_key",
            ].every(function (key) { return key in request && typeof Reflect.get(request, key) === "string"; }) ||
            !("tally_session_id" in request) ||
            !(request.tally_session_id === null || typeof request.tally_session_id === "string"))
            throw new Error("Invalid custody request.");
        actions.push({
            id: action.id,
            kind: "CREATE_CUSTODY_PROOF",
            request: request,
        });
    };
    for (var _i = 0, _a = value.actions; _i < _a.length; _i++) {
        var action = _a[_i];
        _loop_1(action);
    }
    return actions;
}
var boardPattern = /^(dkg_[0-9a-f]{32}|tally_[0-9a-f]{32}_[0-9]+)$/;
export function parseBoards(value) {
    if (typeof value !== "object" ||
        value === null ||
        !("boards" in value) ||
        !Array.isArray(value.boards))
        throw new Error("Invalid trustee board response.");
    return value.boards.map(function (board) {
        if (typeof board !== "object" ||
            board === null ||
            !("name" in board) ||
            typeof board.name !== "string" ||
            !boardPattern.test(board.name) ||
            !("kind" in board) ||
            !("parent" in board))
            throw new Error("Invalid trustee board response.");
        if (board.kind === "DKG" && board.name.startsWith("dkg_") && board.parent === null)
            return { name: board.name, kind: "DKG", parent: null };
        if (board.kind === "TALLY" &&
            board.name.startsWith("tally_") &&
            typeof board.parent === "string" &&
            /^dkg_[0-9a-f]{32}$/.test(board.parent))
            return { name: board.name, kind: "TALLY", parent: board.parent };
        throw new Error("Invalid trustee board response.");
    });
}
/**
 * The board's token provider over `token`, the signed-in user's in-memory
 * access token. It is read before each board request, so it is fresh after
 * long computations; the trustee never persists it.
 */
export function boardTokenProvider(token) {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var current;
        return __generator(this, function (_a) {
            current = token();
            if (!current)
                throw new Error("Sign in as a trustee to reach the board service.");
            return [2 /*return*/, current];
        });
    }); };
}
/** Every engine reaches the board service with the portal's current access token. */
export function createBrowserTrustee(module, name, keys, boardUrl, token) {
    return new module.BrowserTrustee(name, keys, boardUrl, boardTokenProvider(token));
}
function trusteeGraphql(platform_1, token_1, query_1) {
    return __awaiter(this, arguments, void 0, function (platform, token, query, variables) {
        var response, result;
        var _a;
        if (variables === void 0) { variables = {}; }
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!token)
                        throw new Error("Sign in as a trustee to run assigned boards.");
                    return [4 /*yield*/, fetch(platform, {
                            method: "POST",
                            headers: {
                                "Authorization": "Bearer ".concat(token),
                                "Content-Type": "application/json",
                                "x-hasura-role": "trustee-ceremony",
                            },
                            body: JSON.stringify({ query: query, variables: variables }),
                        })];
                case 1:
                    response = _b.sent();
                    if (!response.ok)
                        throw new Error("Trustee API request failed (".concat(response.status, ")."));
                    return [4 /*yield*/, response.json()];
                case 2:
                    result = _b.sent();
                    if ((_a = result.errors) === null || _a === void 0 ? void 0 : _a.length)
                        throw new Error(result.errors.map(function (error) { return error.message; }).join("; "));
                    if (!result.data)
                        throw new Error("Invalid trustee API response.");
                    return [2 /*return*/, result.data];
            }
        });
    });
}
/** Discover assigned boards through the platform's public GraphQL endpoint. */
export function listBrowserTrusteeBoards(platform, token) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, trusteeGraphql(platform, token, "query ListTrusteeBoards { list_trustee_boards { boards { name kind parent } } }")];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, parseBoards(data.list_trustee_boards)];
            }
        });
    });
}
/**
 * One sequential cycle; callers never overlap cycles or release a busy engine.
 * `token` is read before each request: `advance` can outlast an access token.
 */
export function runBrowserCycle(engine, platform, token, remember) {
    return __awaiter(this, void 0, void 0, function () {
        var data, boards, actions, _i, actions_1, action, outcome, acknowledgement, reports, _a, _b, _c, reports_1, report, data_1;
        var _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0: return [4 /*yield*/, trusteeGraphql(platform, token(), "query TrusteeEventUpdates { trustee_event_updates }")];
                case 1:
                    data = _f.sent();
                    boards = parseBoards(data.trustee_event_updates);
                    actions = parseCustodyActions(data.trustee_event_updates);
                    remember(boards);
                    _i = 0, actions_1 = actions;
                    _f.label = 2;
                case 2:
                    if (!(_i < actions_1.length)) return [3 /*break*/, 5];
                    action = actions_1[_i];
                    outcome = void 0;
                    try {
                        outcome = {
                            status: "READY",
                            custody_proof_json: engine.attest(JSON.stringify(action.request)),
                        };
                    }
                    catch (error) {
                        outcome = {
                            status: "FAILED",
                            detail: error instanceof Error ? error.message : String(error),
                        };
                    }
                    return [4 /*yield*/, trusteeGraphql(platform, token(), "mutation SubmitTrusteeActionResult($result: jsonb!) { submit_trustee_action_result(result: $result) { accepted } }", { result: __assign({ id: action.id, request: action.request }, outcome) })];
                case 3:
                    acknowledgement = _f.sent();
                    if (((_d = acknowledgement.submit_trustee_action_result) === null || _d === void 0 ? void 0 : _d.accepted) !== true)
                        throw new Error("The platform did not acknowledge the custody action.");
                    _f.label = 4;
                case 4:
                    _i++;
                    return [3 /*break*/, 2];
                case 5:
                    _b = (_a = JSON).parse;
                    return [4 /*yield*/, engine.advance(JSON.stringify(boards))];
                case 6:
                    reports = _b.apply(_a, [_f.sent()]);
                    _c = 0, reports_1 = reports;
                    _f.label = 7;
                case 7:
                    if (!(_c < reports_1.length)) return [3 /*break*/, 10];
                    report = reports_1[_c];
                    return [4 /*yield*/, trusteeGraphql(platform, token(), "mutation ReportTrusteeBoard($report: jsonb!) { report_trustee_board(report: $report) { accepted } }", { report: report })];
                case 8:
                    data_1 = _f.sent();
                    if (((_e = data_1.report_trustee_board) === null || _e === void 0 ? void 0 : _e.accepted) !== true)
                        throw new Error("The platform did not acknowledge the halted board.");
                    engine.settle(report.board);
                    _f.label = 9;
                case 9:
                    _c++;
                    return [3 /*break*/, 7];
                case 10: return [2 /*return*/, boards];
            }
        });
    });
}
/** Hold one identity's runner lock until the active protocol cycle has stopped. */
export function runExclusiveBrowserTrustee(identity, run) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!navigator.locks)
                        throw new Error("Browser trustees require the Web Locks API.");
                    return [4 /*yield*/, navigator.locks.request("sequent-wbraid-run:".concat(identity), { ifAvailable: true }, function (lock) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!lock)
                                            throw new Error("This trustee is already running in another tab.");
                                        return [4 /*yield*/, run()];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
